exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MarketingPosition[data-v-42ea09b0]{padding:20px}.MarketingPosition .Toggle[data-v-42ea09b0]{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;margin-right:30px;cursor:pointer}.MarketingPosition .Toggle .Toggle_name[data-v-42ea09b0]{font-weight:600;font-size:14px;color:#474245}.MarketingPosition .Toggle .Select_Toggle_name[data-v-42ea09b0]{font-weight:600;font-size:14px;color:#4d8aff}.MarketingPosition .Toggle .Toggle_whorl[data-v-42ea09b0]{margin-top:4px;width:24px;height:4px;background:#4d8aff;border-radius:4px}", ""]);

// exports
